import React from 'react';


interface IPercentTicketProps {
  height?: string;
  width?: string;
  style?: any;
}

class PercentTicket extends React.Component<IPercentTicketProps, any> {
  public static defaultProps = {
    height: "24",
    width: "24",
  };

  render() {
    return (
      <svg style={{width: this.props.width, height: this.props.height}} width={this.props.width}
           height={this.props.height} viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="12">
          <rect width="20" height="12" fill="#C4C4C4"/>
        </mask>
        <g mask="url(#mask0)">
          <path d="M13.3055 4.8999L13.9707 4.8999L13.9707 4.1999L13.3055 4.1999L13.3055 4.8999Z" fill="#FBFBFB"/>
          <path d="M13.3045 3.5L13.9697 3.5L13.9697 2.8L13.3045 2.8L13.3045 3.5Z" fill="#FBFBFB"/>
          <path d="M13.3045 2.1001L13.9697 2.1001L13.9697 1.4001L13.3045 1.4001L13.3045 2.1001Z" fill="#FBFBFB"/>
          <path d="M13.3055 6.2998L13.9707 6.2998L13.9707 5.5998L13.3055 5.5998L13.3055 6.2998Z" fill="#FBFBFB"/>
          <path d="M13.3045 7.69995L13.9697 7.69995L13.9697 6.99995L13.3045 6.99995L13.3045 7.69995Z" fill="#FBFBFB"/>
          <path d="M13.3045 9.09985L13.9697 9.09985L13.9697 8.39985L13.3045 8.39985L13.3045 9.09985Z" fill="#FBFBFB"/>
          <path d="M13.3055 10.4996L13.9707 10.4996L13.9707 9.79963L13.3055 9.79963L13.3055 10.4996Z" fill="#FBFBFB"/>
          <path d="M17.9608 10.4996L18.626 10.4996L18.626 9.79963L17.9608 9.79963L17.9608 10.4996Z" fill="#FBFBFB"/>
          <path d="M1.3299 10.4996L1.99512 10.4996L1.99512 9.79963L1.3299 9.79963L1.3299 10.4996Z" fill="#FBFBFB"/>
          <path d="M1.3299 2.1001L1.99512 2.1001L1.99512 1.4001L1.3299 1.4001L1.3299 2.1001Z" fill="#FBFBFB"/>
          <path d="M17.9608 2.1001L18.626 2.1001L18.626 1.4001L17.9608 1.4001L17.9608 2.1001Z" fill="#FBFBFB"/>
          <path
            d="M0.33214 7.69998C0.148457 7.69998 -0.000468856 7.85669 -0.000468873 8.04998L-0.000474906 11.6344C-0.000474934 11.9531 -0.106726 11.9 0.33214 11.9L19.6234 11.9C19.8071 11.9 19.9561 11.7433 19.9561 11.55L19.9561 8.04998C19.9561 7.85669 19.8071 7.69998 19.6234 7.69998C18.705 7.69998 17.9604 6.91646 17.9604 5.94998C17.9604 4.98349 18.705 4.19997 19.6234 4.19997C19.8071 4.19997 19.9561 4.04326 19.9561 3.84997L19.9561 0.349962C19.9561 0.156674 19.8071 -3.81601e-05 19.6234 -3.81762e-05L0.332141 -3.98733e-05C-0.000468174 -3.99025e-05 -0.000468171 -0.0339259 -0.000468187 0.159362L-0.000468508 3.84997C-0.000468525 4.04326 0.148457 4.19997 0.332141 4.19997C1.2506 4.19997 1.99518 4.98349 1.99518 5.94998C1.99518 6.91646 1.2506 7.69998 0.33214 7.69998ZM2.63862 5.6019C2.49177 4.52521 1.6879 3.67934 0.664748 3.52482L0.664748 0.699961L19.2908 0.699963L19.2908 3.52482C18.018 3.71706 17.1343 4.95864 17.317 6.29805C17.4638 7.3747 18.2676 8.22061 19.2908 8.37513L19.2908 11.2L0.664747 11.2L0.664748 8.37513C1.93756 8.18289 2.8213 6.94131 2.63862 5.6019Z"
            fill="#FBFBFB"/>
          <path
            d="M9.97816 9.44995C10.7129 9.44995 11.3086 8.82314 11.3086 8.04995C11.3086 7.27675 10.7129 6.64994 9.97816 6.64994C9.24338 6.64994 8.64772 7.27675 8.64772 8.04995C8.64772 8.82314 9.24338 9.44995 9.97816 9.44995ZM9.97816 7.34995C10.3456 7.34995 10.6434 7.66333 10.6434 8.04995C10.6434 8.43657 10.3456 8.74995 9.97816 8.74995C9.61075 8.74995 9.31294 8.43657 9.31294 8.04995C9.31294 7.66333 9.61075 7.34995 9.97816 7.34995Z"
            fill="#FBFBFB"/>
          <path
            d="M5.98695 5.42493C6.72172 5.42493 7.31738 4.82739 7.31738 4.09031C7.31738 3.35322 6.72172 2.75569 5.98695 2.75569C5.25217 2.75569 4.65651 3.35322 4.65651 4.09031C4.65651 4.82739 5.25217 5.42493 5.98695 5.42493ZM5.98695 3.423C6.35436 3.423 6.65217 3.72174 6.65217 4.09031C6.65217 4.45887 6.35436 4.75762 5.98695 4.75762C5.61954 4.75762 5.32173 4.45887 5.32173 4.09031C5.32173 3.72174 5.61954 3.423 5.98695 3.423Z"
            fill="#FBFBFB"/>
          <path d="M10.4076 3.18825L5.08594 8.52661L5.55631 8.99847L10.8779 3.66011L10.4076 3.18825Z" fill="#FBFBFB"/>
        </g>
      </svg>
    )
  }
}

export default PercentTicket;
